<template>
  <div>
    <div class="upInfo" v-if="istop">
      <div class="upBack">
        <div class="upStoreName">
          <img :src="sellerInfo.StoreLogo">
          <span>{{sellerInfo.StoreName}}</span>
        </div>
        <div class="upStoreSave">
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="infoOperate">
        <div class="bestMatch">{{$t('base.bestMatch')}}</div>
        <div class="grid_filter">
          <div class="grid"></div>
          <div class="grid filter">{{$t('base.filter')}}</div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="storeLogo">
        <img :src="sellerInfo.StoreLogo">
      </div>
      <div class="storeBox">
        <div class="storeInfo">
          <div class="storeInfoBox">
            <div class="imgText">
              <img :src="sellerInfo.StoreLogo">
              <div class="">
                <div class="storeName">{{sellerInfo.StoreName}}</div>
                <div class="text_gray storeFeedback">
                  <span>{{sellerInfo.FollowerCount}} {{$t('base.followers')}}</span>
                  <span>{{sellerInfo|setFeedback}} {{$t('base.PositiveFeedback')}}</span>
                </div>
              </div>
            </div>
            <div class="StoreSave">
              <span></span>
              <span></span>
            </div>
          </div>
          <div class="AboutStore text_gray line_txt2">{{sellerInfo.AboutStore == null?'Not mentioned about the store':sellerInfo.AboutStore}}</div>
        </div>
        <div class="storeList">
          <div class="storeListInfo">
            <div class="infoCount text_blue">{{TotalCount + (TotalCount != 1 ? ' Items are ':' Item is ') +'selling'}}</div>
            <div class="infoOperate">
              <div class="bestMatch">{{$t('base.bestMatch')}}</div>
              <div class="grid_filter">
                <div class="grid"></div>
                <div class="grid filter">{{$t('base.filter')}}</div>
              </div>
            </div>
            <div class="radius"></div>
            <div class="radius bigRadius"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cradListBox" :class="istop?'up':''">
      <div v-for="(item,index) in list" :key="index" class="cradList">
        <a href="" class="ListLink">
          <img :src="item.TitImg">
          <div class="listDetail">
            <p class="line_txt3">{{item.Title}}</p>
            <div class="cardinfo">
              <div class="cardPrice text_blue"><em>$</em> {{item.USD_Price}}</div>
              <div class="cardinfo_bid">
                <span class="icon_bid" v-if="item.ByWay!=1">
                  {{ item.OutCount }} {{ item.OutCount != 1?'bids':'bid'}}
                </span>
                <span class="icon_bid icon_flash" v-else >{{$t('base.buyNow')}}</span>
                <span class="">{{CountDown(item.EffectiveDate)}}</span>
                <span class="icon_abc"></span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="fixed">
      <div class="btn">{{$t('base.open')}}</div>
    </div>
  </div>
</template>
<script>
import { countDown,getInfo,setUTC, GetWindowsWidth } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    return {
      bigHeight: 'auto',
      sellerInfo: '',
      TotalCount: 0,
      list: [],
      CategoryKeys: [{ "Key": "Status", "Value": 1 }],
      sort: 'EffectiveTimeStamp',
      sortType: 'asc',
      pi: 1,
      ps: 60,
      istop: false,
      timer: "",
      nowData: new Date().getTime(),
    }
  },

  filters: {
    //百分比
    setFeedback(val) {
      let data = ((val.BuyFavorableCount / (val.BuyFavorableCount + val.BuyNegativeCount)) * 100)
      if (val.BuyFavorableCount + val.BuyNegativeCount > 0) {
        if (data != 100) {
          data = data.toFixed(2)
        }
      } else {
        data = 100
      }
      return data + ' %'
    }
  },
  mounted() {
    let that=this
    window.addEventListener('scroll', function() {
      if (document.documentElement.scrollTop > 420) {
        that.istop = true
      } else {
        that.istop = false
      }
    })
  },
  created() {
    this.GetStoresList();
    this.cardTimer()
  },
  methods: {
    //设置头图高度
    SetHeight() {
      let getWidth = GetWindowsWidth()
      return 'height:' + getWidth + 'px'
    },
    // 获取店铺详细
    GetStoresList() {
      let that = this
      let data = { 'Id': this.$route.params.id, 'MemberId': '' }
      if (that.userInfo != null) {
        data.MemberId = that.userInfo.MappingUserId
      }
      this.$get(this.$interface.GetStoreDetail, data).then(res => {
        if (res.result != 0) {
          that.sellerInfo = res.data
          that.TotalCount = that.sellerInfo.CommoditySellCount
          document.title = that.sellerInfo.StoreName;
          that.CategoryKeys.push({ "Key": "CreateUser", "Value": that.sellerInfo.Id })
          that.GetStoresGoods()
          // if (val == 1) {
          //   that.GetStoresGoods()
          // }
        }
      })
    },
    GetStoresGoods() {
      let that = this;
      let SeachJson = JSON.stringify(that.CategoryKeys);
      let data = { userId: '', pageIndex: that.pi, pageSize: that.ps, searchKey: '', searchJson: SeachJson, sort: that.sort, sortType: that.sortType }
      this.$get(this.$interface.SearchCommodity, data).then(res => {
        console.log(res)
        if (res.result != 0) {
          var data = res.data;
          that.pi = parseInt(data.PageIndex)
          that.TotalCount = parseInt(data.TotalCount)
          that.list = [...that.list, ...data.PagedMarketItemList]
        }
      })
    },
    cardTimer() {
      this.timer = setInterval(() => {
        this.nowData = this.nowData + 1000;
      }, 1000);
    },
    CountDown(itemEnd) {
      itemEnd = itemEnd.toString().replace(/-/g, "/")
      let val = setUTC(itemEnd, -8,'cn')
      let newval = setUTC(this.nowData, -8)
      return countDown(val, newval)
    },
  }
}

</script>
<style scoped>
.storeLogo {
  width: 100%;
  height: 248px;
  overflow: hidden;
  position: relative;
}

.upInfo {
  padding: 12px;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  background: #fff;
}

.upStoreName {
  display: flex;
  align-items: center;
}

.upBack {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  position: relative;
}

.upStoreSave {}

.upStoreSave span {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  background: #f7f7f7 url(../../../static/images/app/comment.svg) center no-repeat;
}

.upStoreSave span:last-child {
  margin-left: 16px;
  background-image: url(../../../static/images/app/attention.svg);
}

.upStoreName img {
  object-fit: cover;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 4px;
}

.storeLogo img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.AboutStore {
  margin-top: 12px;
}

.storeInfo {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  padding: 12px;
  margin-top: -8px;
  z-index: 3;
  font-size: 12px;
  position: relative;
}

.storeInfoBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.imgText {
  display: flex;
}

.imgText img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  margin-right: 8px;
}

.StoreSave {}

.StoreSave span {
  width: 24px;
  height: 24px;
  display: inline-block;
  background: url(../../../static/images/app/comment1.svg) center no-repeat;
}

.StoreSave span:last-child {
  margin-left: 16px;
  background-image: url(../../../static/images/app/attention1.svg);
}

.storeFeedback {
  margin-top: 9px;
}

.storeFeedback span:first-child {
  display: inline-block;
  margin-right: 12px;
}

.storeListInfo {
  width: 100%;
  height: 82px;
  border-radius: 8px 8px 0 0;
  position: relative;
  padding: 12px;
  background: linear-gradient(180deg, #DFE2EF 0%, #F7F7F7 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.storeName {
  position: relative;
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  line-height: 18.4px;
}

.storeName::after {
  content: '';
  width: 5px;
  height: 5px;
  right: -10px;
  bottom: 7px;
  border-right: 1px solid #a0a0a0;
  border-bottom: 1px solid #a0a0a0;
  transform: rotate(-45deg);
  position: absolute;
}

.infoCount {
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  line-height: 18.4px;
  position: relative;
  z-index: 1;
}

.infoOperate {
  display: flex;
  justify-content: space-between;
}

.infoOperate .bestMatch {
  position: relative;
  line-height: 16px;
}

.infoOperate .bestMatch::after {
  content: '';
  width: 5px;
  height: 5px;
  right: -10px;
  bottom: 7px;
  border-right: 1px solid #333;
  border-bottom: 1px solid #333;
  transform: rotate(45deg);
  position: absolute;
}

.infoOperate #Grid {
  display: flex;
}

.grid_filter {
  display: flex;
}

.infoOperate .grid {
  background: url(../../../static/images/app/grid.svg) no-repeat;
  padding-left: 20px;
  margin-left: 12px;
  min-height: 16px;
}

.infoOperate .filter {
  background-image: url(../../../static/images/app/filter.svg);
}

.radius {
  width: 29px;
  height: 29px;
  background: rgba(255, 255, 255, 0.24);
  position: absolute;
  left: 244px;
  top: 10px;
  border-radius: 50%;
  z-index: 0;
}

.bigRadius {
  width: 140px;
  height: 140px;
  left: 52px;
  top: -89px;
}

.cradListBox {
  padding: 12px;
  padding-bottom: 45px;
}
.cradListBox.up{
  padding-top: 170px;
}

.cradList {
  margin-bottom: 12px;
}

.cradList .listDetail {
  flex: 1;
  margin-left: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ListLink {
  display: flex;
}

.ListLink>img {
  width: 132px;
  height: 132px;
  object-fit: cover;
  border-radius: 6px;
}
.icon_bid{
  background: url(../../../static/images/app/bid.svg) no-repeat;
  padding-left: 20px;
}
.icon_flash{
  background-image: url(../../../static/images/app/flash.svg);
}
.icon_abc{
  background: url(../../../static/images/app/collect.svg) no-repeat;
  padding-left: 20px;
}
.cardinfo_bid{
  font-size: 14px;
  line-height: 16.1px;
  display: flex;
  justify-content: space-between;
}
.cardPrice{
  font-size: 16px;
  line-height: 18.4px;
  font-weight: bold;
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
}
.cardPrice em{
  font-size: 12px;
  font-weight: normal;
  margin-right: 2px;
}.fixed {
  position: fixed;
  width: 100%;
  padding: 5px 8px;
  left: 0;
  bottom: 0;
  background-color: #fff;
}

.fixed .btn {
  height: 40px;
  width: 100%;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background-color: #5F6DAE;
  border-radius: 6px;
}

</style>



// WEBPACK FOOTER //
// src/pages/shared/shareseller.vue